import { Link } from 'react-router-dom';
import { Button } from 'antd';
import Banner from './Banner';
import { formatDate } from '../utils/format';

// Drives the colored banner from /me's `subscription` block.
//   active     → no banner
//   reminder   → info (renewal due)
//   grace      → warning (past period end, still usable)
//   suspended  → danger (must renew)

const TONE_BY_STATUS = {
  reminder: 'info',
  grace: 'warning',
  suspended: 'danger'
};

const TITLE_BY_STATUS = {
  reminder: 'Renewal coming up',
  grace: 'Subscription in grace period',
  suspended: 'Subscription suspended'
};

export default function SubscriptionBanner({ subscription }) {
  if (!subscription) return null;
  const { effectiveStatus, message, subscriptionEndsAt, graceEndsAt } =
    subscription;
  if (!effectiveStatus || effectiveStatus === 'active') return null;

  const tone = TONE_BY_STATUS[effectiveStatus] || 'info';
  const title = TITLE_BY_STATUS[effectiveStatus] || 'Subscription notice';

  const detail =
    effectiveStatus === 'suspended'
      ? `Suspended after ${formatDate(graceEndsAt)}. Renew to restore access for everyone on your tenant.`
      : effectiveStatus === 'grace'
        ? `Grace period ends ${formatDate(graceEndsAt)} — usage continues without interruption until then.`
        : `Renewal due before ${formatDate(subscriptionEndsAt)}.`;

  return (
    <div className="mb-5">
      <Banner
        tone={tone}
        title={message || title}
        description={detail}
        action={
          <Link to="/subscription">
            <Button
              type={tone === 'danger' ? 'primary' : 'default'}
              danger={tone === 'danger'}
              size="small"
            >
              Manage subscription
            </Button>
          </Link>
        }
      />
    </div>
  );
}
